import useNewsletterSignupPersonal from './useNewsletterSignupPersonal';

export default useNewsletterSignupPersonal;
